<template>
  <v-dialog width="400" v-model="mostrarModalImportar" persistent>
    <template slot="activator">
      <az-call-to-action active css-class="ma-0" class="text-uppercase">
        <v-icon>upload</v-icon>
        Importar IPM
      </az-call-to-action>
    </template>

    <v-card>
      <v-card-title class="primary modal-title" primary-title>
        <span>Importar da IPM</span>
        <v-btn flat depressed @click="fecharModalImportar">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container class="mt-2" grid-list-md>
          <v-layout white class="pb-2">
            <v-flex md12 sm12 xs12>
              <v-text-field name="CNPJ" label="CNPJ"
                            placeholder="CNPJ" key="CNPJ"
                            v-validate="'required'" class="required-field"
                            :error-messages="errors.collect('CNPJ')"
                            v-model="cnpj"/>
            </v-flex>
            <v-flex md12 sm12 xs12>
              <v-text-field name="Número do Processo" label="Número do Processo"
                            placeholder="Número do Processo" key="Número do Processo"
                            v-validate="'required'" class="required-field"
                            :error-messages="errors.collect('Número do Processo')"
                            v-model="processo"/>
            </v-flex>
          </v-layout>
          <v-layout white class="pb-2">
            <v-flex md12 sm12 xs12>
              <v-select name="Ano" label="Ano" placeholder="Ano" key="Ano"
                        v-validate="'required'" class="required-field"
                        :error-messages="errors.collect('Ano')"
                        v-model="ano" :items="getRangeAnos()" item-text="descricao" item-value="id"/>
            </v-flex>
          </v-layout>
          <v-layout white>
            <v-flex md12 sm12 xs12>
              <v-select name="Modalidade" label="Modalidade" placeholder="Selecione" key="Modalidade"
                        v-validate="'required'" class="required-field"
                        :error-messages="errors.collect('Modalidade')"
                        v-model="modalidade" :items="modalidades" item-text="descricao" item-value="id"/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-layout>
          <v-flex md2 sm2 xs2>
            <az-call-to-action active @click="importarProcesso" slot="actions">
              Importar
            </az-call-to-action>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {actionTypes} from '@/commons/constants'

export default {
  name: 'ImportarProcessoIpm',
  inject: ['$validator'],
  data() {
    return {
      modalidades: [
        {id: 1, descricao: 'Pregão Eletrônico', valor: 'pregao-eletronico'},
        {id: 2, descricao: 'Concorrência Eletrônica', valor: 'concorrencia-eletronica'}
      ],
      mostrarModalImportar: false,
      cnpj:null,
      processo: null,
      modalidade: null,
      ano: null,
    }
  },
  methods: {
    getRangeAnos(){
      const anoAtual = new Date().getFullYear()
      return [anoAtual - 3, anoAtual - 2, anoAtual - 1, anoAtual, anoAtual + 1]
    },
    async importarProcesso() {
      const valido = await this.$validator.validateAll()
      if(!valido){
        this.mostrarNotificacaoErro("Preencha corretamente os campos!")
        return
      }

      let modalidadeSelecionada = this.modalidades.filter(modalidade => modalidade.id == this.modalidade)

      const payload={
        cnpj: this.cnpj,
        numero: this.processo,
        modalidade: modalidadeSelecionada[0].valor,
        ano: this.ano
      }
      this.habilitarLoadingGlobal()
      this.setMensagemLoading('Importando o processo da IPM...')
      const resposta = await this.$store.dispatch(actionTypes.IMPORTAR_PROCESSO_IPM, payload)
      this.fecharModalImportar()
      this.limparCampoModal()
      this.mostrarNotificacaoSucesso('Número de processo importado com sucesso.')
      this.irParaEdicaoLicitacao(resposta.licitacaoId)
    },
    irParaEdicaoLicitacao(id) {
      this.$router.push({name: 'licitacao', params: {id}, query: {edicao: true}})
    },
    fecharModalImportar() {
      this.limparCampoModal()
      this.mostrarModalImportar = false
    },
    limparCampoModal() {
      this.processo = null
      this.modalidade = null
      this.ano = null
    },
    focusInput() {
      this.$refs.processoAutocomplete.focus()
    },
  },
  watch: {
    mostrarModalImportar: {
      handler(novoValor){
        if(novoValor === true){
          setTimeout(() => {
            this.focusInput()
          }, 300)
        }
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.modal-title
  justify-content space-between

  span
    width 90%

  .v-btn
    padding 0
    margin 0
    color #fff
    box-sizing border-box
    min-width 25px

.botao-menor
  color #fff
  border-radius 2px
  padding 5px 10px
  box-sizing border-box

  &:hover, &:focus, &:active
    background-color var(--v-secondary-lighten1) !important

@media (max-width 500px)
  .modal-title span
    width 80%
</style>
